
const heavyMachineryProducts = [
  {
    id: "01",
    title: "Construction Equipment",
    image: "/Construction Equipment.jpg",
    description:
      "Heavy-duty construction machinery designed for infrastructure, defence engineering and large-scale civil projects.",
    products: [
      "Excavators",
      "Bulldozers",
      "Wheel Loaders",
      "Backhoe Loaders",
      "Motor Graders",
      "Skid Steer Loaders",
    ],
  },

  {
    id: "02",
    title: "Earth Moving Equipment",
    image: "/Earth Moving Equipment.jpg",
    description:
      "Reliable earth moving machinery for demanding construction and engineering operations.",
    products: [
      "Crawler Dozers",
      "Wheel Dozers",
      "Dump Trucks",
      "Scrapers",
      "Compactors",
      "Soil Stabilizers",
    ],
  },

  {
    id: "03",
    title: "Material Handling Equipment",
    image: "/Material Handling Equipment.jpg",
    description:
      "Industrial equipment designed for lifting, transporting and handling heavy materials safely and efficiently.",
    products: [
      "Forklifts",
      "Reach Stackers",
      "Telehandlers",
      "Container Handlers",
      "Material Lifters",
    ],
  },

  {
    id: "04",
    title: "Lifting Equipment",
    image: "/Lifting Equipment.jpg",
    description:
      "Heavy lifting solutions supporting industrial, military and infrastructure projects.",
    products: [
      "Mobile Cranes",
      "Crawler Cranes",
      "Tower Cranes",
      "Truck Mounted Cranes",
      "Hydraulic Cranes",
    ],
  },

  {
    id: "05",
    title: "Mining & Industrial Machinery",
    image: "/Mining & Industrial Machinery.jpg",
    description:
      "Heavy industrial machinery developed for mining, quarrying and large-scale industrial applications.",
    products: [
      "Mining Excavators",
      "Drilling Machines",
      "Rock Breakers",
      "Industrial Crushers",
      "Screening Equipment",
    ],
  },

  {
    id: "06",
    title: "Support & Engineering Equipment",
    image: "/Support & Engineering Equipment.jpg",
    description:
      "Engineering support equipment providing reliable operation across construction and defence infrastructure projects.",
    products: [
      "Power Generators",
      "Air Compressors",
      "Concrete Equipment",
      "Water Pumps",
      "Maintenance Equipment",
      "Workshop Machinery",
    ],
  },
];

export default heavyMachineryProducts;